<template>
  <div v-if="readyToRender">
    <div class="row" style="padding-bottom: 20px;">
      <div class="col-md-12">
        <h3>Envoyer un message reçu de la permanence téléphonique</h3>
        <div v-if="!origin">
          <span class="top-label">Recherche du destinataire</span>

          <div class="row" style="display:flex;">
            <div class="form-group col-md-12">
              <search-and-select :initial-value="selectedCustomerId"
                :search-config="hotlineCustomerSearchConfig"
                :get-option-label="getCustomerNameWithRepresentativeAndErpId"
                @field-updated="updateCustomer">
              </search-and-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-bottom: 20px;">
      <div class="form-group col-md-12" v-if="preparedContracts.length > 0">
        <div class="top-label">Sélection du contrat</div>

        <custom-select :field="customerContractField" 
          :value="customerContractField.value" 
          :field_idx="1"
          @field-updated="onCustomerContractFieldUpdate">
        </custom-select>
      </div>

      <div class="form-group col-md-12" v-else-if="selectedCustomer">Aucun contrat éligible pour ce client.</div>
    </div>

    <div class="row">
      <div v-if="selectedContract" class="col-md-4 col-sm-12">
        <h6 style="font-size:14px;font-weight:bold;">&gt; Pour le contrat {{ selectedContract.offer.distributed_product.agency.name }}</h6>

        <hotline-instruction :contract="selectedContract"></hotline-instruction>

        <hotline-contacts :contract="selectedContract"></hotline-contacts>
      </div>

      <div v-show="selectedContract" class="card-default col-md-8 col-sm-12">
        <div class="form-hotline">
          <div class="row">
            <div class="col-md-6">
              <span class="top-label">Détails du message</span>

              <div class="form-group">
                <label>Société : </label>
                <input type="text" class="form-control" required v-model="sender.company_name" :disabled="is_fetching">
              </div>

              <div class="form-group">
                <label>Nom et prénom: </label>
                <input type="text" class="form-control" required v-model="sender.fullname" :disabled="is_fetching">
              </div>
            </div>

            <div class="col-md-6">
              <span class="top-label">&nbsp;</span>

              <div class="form-group">
                <label>Email : </label>
                <input type="email" class="form-control" required v-model="sender.email" :disabled="is_fetching">
              </div>

              <div class="form-group">
                <label>Téléphone : </label>
                <input type="text" class="form-control" required v-model="sender.phone" :disabled="is_fetching">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <span class="top-label">Reçu le</span>

              <div  class="input-group date">
                <input id="myDatepicker" type="text" class="form-control tip date-time-field" v-model="message.date_received" :disabled="is_fetching">
                <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
              </div>
            </div>
            <div class="col-md-6">
              <span class="top-label">Reçu à</span>

              <div class="input-group bootstrap-timepicker">
                <input id="timepicker" type="text" class="form-control" :disabled="is_fetching">
                <span class="input-group-addon"><i class="pg-clock"></i></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <span class="top-label">Message</span>

              <textarea class="form-control" id="informations" rows="10" v-model="message.body" :disabled="is_fetching">
              </textarea>

              <button class="btn btn-complete m-t-10" @click="sendDatas()" v-if="selectedCustomer && selectedContractOption && message.date_received && message.time_received">Envoyer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .top-label {
    padding: 0 12px 5px 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 600;
    display: inline-block;
  }
  button {
    float: right;
  }

  .form-hotline {
    background:white;
    border:solid 1px #ddd;
    padding:30px;
    margin-bottom: 20px;
  }
</style>


<script type="text/babel">
import {mapState, mapActions, mapGetters} from "vuex"
import HotlineInstruction from './HotlineInstruction'
import HotlineContacts from './HotlineContacts'
import SearchAndSelect from 'components/Forms/Elements/SearchAndSelect'
import CustomSelect from 'components/Forms/Elements/Select'

import customerMixin from 'mixins/customer'
import searchMixin from 'mixins/search'

  export default {

    components: {
      HotlineInstruction,
      HotlineContacts,
      SearchAndSelect,
      CustomSelect
    },

    mixins: [customerMixin, searchMixin],

    props: ["origin"],

    data() {
      return {
        selected_agency: null,
        selectedCustomerId: null,
        selectedCustomer: null,
        selectedContract: null,
        sender:{
          fullname: "",
          company_name: "",
          email: "",
          phone: "",
        },
        message: {
          body: "",
          date_received: moment().format("YYYY-MM-DD"),
          time_received: moment().format("HH:mm"),
        },
        no_results: false
      }
    },

    methods: {
      ...mapActions('hotline', [
        'updateSearchFilters', 'set_fetching_state','create_hotline_message',
        'customersByKeywords','reset_error','reset_customers',"reset_hotline_errors",
        'resetContracts', 'contractsCustomer'
      ]),

      initialize() {
        var main_agency = _.find(this.user.agencies, (agency) => !agency.virtual)

        if (main_agency != undefined) {
          this.selected_agency = main_agency.id
        }
      },

      sendDatas() {
        this.reset_error()
        
        var params = {
          customer_id: this.selectedCustomerId,
          contract: this.selectedContract,
          params: {
            contract_option_id: this.selectedContractOption.id,
            calling_date: this.message.date_received + ' ' + this.message.time_received + ':00',
            contact: this.sender.fullname,
            company: this.sender.company_name,
            email: this.sender.email,
            phone: this.sender.phone,
            message: this.message.body
          },
          related_customer: this.selectedCustomer
        }

        this.$emit('toggle-modal', params)
      },

      updateCustomer(event) {
        if (event && event.hasOwnProperty('id')) {
          this.selectedCustomerId = event.id
        } else {
          this.selectedCustomerId = null
        }
      },
      
      assignSelectedContract(contract) {
        this.selectedContract = contract
      },

      onCustomerContractFieldUpdate(event) {
        // If the update corresponds to a deselection, we reset the concerned fields
        if (!event.new_value) {
          this.assignSelectedContract(null)
        } else {
          let correspondingContract = this.contracts.find(function(contract) {
            return contract.id == event.new_value.value
          })

          this.assignSelectedContract(correspondingContract)
        }
      }
    },

    computed: {
      ...mapState(['agencies', 'user']),
      ...mapState('hotline', ['searchFilters','is_fetching']),
      ...mapGetters('hotline', ['userAgenciesIdList','contracts','customers']),

      readyToRender() {
        if (this.user && this.agencies && this.agencies.length > 0 ? true : false) {
          if (this.selected_agency == null) {
            this.initialize()
          }

          return true
        }

        return false
      },

      preparedContracts() {
        // We filter on contracts that have the simple hotline option only
        let filteredContracts = this.contracts.filter(function(contract) {
          return contract.contract_options.filter(function(co) {
            return co.option.simple_hotline
          }).length > 0
        })

        return _.map(filteredContracts, function(contract) {
          return {
            id: contract.id,
            name: contract.order.ihrez + ' (' + contract.offer.distributed_product.agency.name + ')'
          }
        })
      }, 

      customerContractField() {
        return {
          values: this.preparedContracts,
          multiple: false,
          placeholder: "",
          disabled: false,
          idx: 1,
          required: true,
          value: this.selectedContract ? this.selectedContract.id : null,
          label: "",
          type: "select"
        }
      },

      selectedContractOption() {
        if (!this.selectedContract) {
          return null
        }

        return this.selectedContract.contract_options.find(function(co) {
          return co.option.simple_hotline
        })
      }
    },

    beforeDestroy() {
      this.selectedContract = null
      this.resetContracts([])
      this.selectedCustomer = null
      this.selectedCustomerId = null
      this.reset_hotline_errors()
      this.reset_error()
    },

    mounted () {
      if (this.origin) {
        this.selectedCustomerId = this.origin
      }

      $('#myDatepicker', this.$el).datepicker({
        format: 'yyyy-mm-dd',
        language: "fr",
        autoclose: true,
        title: "Date de réception",
      }).on('changeDate', (e) => {
        this.message.date_received = e.target.value
      })
      
      $('#timepicker', this.$el).timepicker({
        showMeridian: false,
        maxHours: 24,
        showInputs: false,
        minuteStep: 1,
      }).on('change', (e) => {
        this.message.time_received = e.target.value
      })
    },

    watch: {
      selectedCustomerId(newv, oldv) {
        this.selectedContract = null
        this.resetContracts([])

        if (newv) {
          this.set_fetching_state(true)
          
          this.axios.get(`customers/${newv}`).then((response) => {
            this.selectedCustomer = response.data.customer

            this.contractsCustomer({
              customer_id: newv, 
              params: {
                with:"active_contract_options"
              }
            }).then(response => {
              if (this.contracts.length == 1) {
                this.assignSelectedContract(this.contracts[0])
              }

              this.set_fetching_state(false)
            })
          })
        } else {
          this.selectedCustomer = null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/HotlineContent/HotlineForm.vue